module.exports = __webpack_public_path__ + "static/CBDC-e37c1db44a156e930a42d44259b19a23.png";